module.exports = __webpack_public_path__ + "img/medpadala_error.30c9ee60.svg";